import { zhttp } from "../Fetch";

export class Suggestions {
	async sendSuggestion(txt: string) {
		let response = await zhttp<{ ok: boolean }>(`/users/me/suggestion`, "POST", { txt: txt.substring(0, 5014) });
		return response;
	}
	async sendLog(txt: string) {
		let response = await zhttp<{ ok: boolean }>(`/log`, "POST", { txt });
		return response;
	}
}
